import { Expose, Type } from 'class-transformer';
import { PaymentProcessDto } from './payment-process.dto';

export class PurchaseSubscriptionResponseDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'user_id' })
  userId: number;
  @Expose({ name: 'event_id' })
  eventId: number;
  @Expose({ name: 'paymentsProcess' })
  @Type(() => PaymentProcessDto)
  paymentsProcess: PaymentProcessDto;
}
